import * as React from 'react';
import SVGIcon from '../SVGIcon';
import { fromNullable } from 'maybeasy';

type IconVariant = 'small' | 'large';
interface Props {
  variant?: IconVariant;
}

const CloseIcon: React.FC<Props> = ({ variant }) => {
  const size = fromNullable(variant).getOrElseValue('large');
  switch (size) {
    case 'small':
      return (
        <SVGIcon viewBox="0 0 18 18" width="18" height="18" fill="none">
          <path
            d="M 3.609 2.891L2.891 3.609L7.281 8L2.891 12.391L3.609 13.109L8 8.719L12.391 13.109L13.109 12.391L8.719 8L13.109 3.609L12.391 2.891L8 7.281L3.609 2.891Z"
            fill="black"
          />
        </SVGIcon>
      );
    case 'large':
      return (
        <SVGIcon viewBox="0 0 24 24" width="24" height="24" fill="none">
          <path
            d="M5.41406 4.33594L4.33594 5.41406L10.9219 12L4.33594 18.5859L5.41406 19.6641L12 13.0781L18.5859 19.6641L19.6641 18.5859L13.0781 12L19.6641 5.41406L18.5859 4.33594L12 10.9219L5.41406 4.33594Z"
            fill="black"
          />
        </SVGIcon>
      );
  }
};

export default CloseIcon;
